import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'

import {
  DATABASE_TYPE_OPTIONS,
  DATABASE_TYPE_NAMES,
  DATABASE_IMAGES,
} from '../../../../utils/databases'

import { emptyDatabaseStep, emptyAPIStep } from '../../../../utils/steps'
import { getCurrentOrganizationId } from '../../../../ducks/users'
import { getDatabases, fetchDatabases } from '../../../../ducks/databases'

import Subnav from '../../../Shared/Subnav'
import Button from '../../../Shared/Button'
import Card from '../../../Shared/Card'
import { FormWrapper } from '../../../Databases/New'

import styles from './ChooseType.module.css'

import apiImage from './images/cloud.png'

const Item = function ChooseTypeItem(props) {
  const { name, image, selected, onSelect, className } = props

  return (
    <div
      className={classNames(styles.item, className, {
        [styles.selected]: selected,
      })}
      onClick={onSelect}
    >
      <div
        className={styles.itemImage}
        style={{ backgroundImage: `url(${image})` }}
      />
      <p className={styles.itemLabel}>{name}</p>
      <div className={styles.selection} />
    </div>
  )
}

const Items = function ChooseTypeItems({ children, title }) {
  return (
    <div className={styles.itemsWrapper}>
      <h5>{title}</h5>
      <div className={styles.items}>{children}</div>
    </div>
  )
}

const DatabaseItems = function ChooseTypeDatabases({
  items,
  selection,
  onChoose,
}) {
  return (
    <Items title="Connected Sources">
      {items.map(itm => (
        <Item
          key={itm.id}
          name={itm.name}
          image={itm.image}
          selected={selection === itm.id}
          onSelect={() => onChoose(itm.id)}
        />
      ))}
    </Items>
  )
}

const NewItems = function ChooseTypeAPIs({ selection, onChoose, history }) {
  return (
    <Items title="New Sources">
      {DATABASE_TYPE_OPTIONS.map(opt => (
        <Item
          name={opt.label}
          image={opt.image}
          onSelect={() => onChoose(opt.value)}
          selected={selection === opt.value}
        />
      ))}
      <Item
        name="API Call"
        image={apiImage}
        onSelect={() => onChoose('api')}
        selected={selection === 'api'}
      />
    </Items>
  )
}

export default function ChooseType({ onChoose, submitting, title }) {
  const history = useHistory()
  const [selection, setSelection] = useState(null)
  const [databaseFormVisible, setDatabaseFormVisible] = useState(false)
  const orgId = useSelector(getCurrentOrganizationId)
  const databases = useSelector(getDatabases(orgId))
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchDatabases(orgId))
  }, [orgId, dispatch])

  const items = databases.map(db => ({
    id: db.id,
    name: db.name,
    image: DATABASE_IMAGES[db.type],
  }))

  const handleChoose = () => {
    if (selection === 'api') {
      return onChoose(emptyAPIStep())
    } else if (DATABASE_TYPE_NAMES[selection]) {
      return handleToggle()
    }

    onChoose(emptyDatabaseStep(selection))
  }

  const handleToggle = () => {
    setDatabaseFormVisible(!databaseFormVisible)

    window.scrollTo(0, 0)
  }

  const handleCreateDatabase = result => {
    onChoose(emptyDatabaseStep(result.id))
  }

  if (databaseFormVisible) {
    return (
      <FormWrapper
        hideType
        title={`Connect your ${DATABASE_TYPE_NAMES[selection]} source`}
        subtitle="Enter details to connect."
        onSuccess={handleCreateDatabase}
        onCancel={handleToggle}
        initialValues={{ type: selection }}
        cancelButtonText="Back"
      />
    )
  }

  return (
    <>
      <Subnav
        title={title || 'Step 1. Choose Step Type'}
        actions={
          <>
            <Button text onClick={history.goBack}>
              Cancel
            </Button>
            <Button
              disabled={!selection}
              onClick={handleChoose}
              loading={submitting}
            >
              Continue
            </Button>
          </>
        }
      />
      <Card>
        <DatabaseItems
          onChoose={setSelection}
          selection={selection}
          items={items}
        />
        <NewItems
          onChoose={setSelection}
          selection={selection}
          history={history}
        />
      </Card>
    </>
  )
}
